<cap-list-loader [listLoader]="listLoader" [showTotal]="showTotal" [showZeilenSelect]="showZeilenSelect">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-detail">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>

<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'Nummer'" [sortModel]="tableSortModel.columns.get('nummer')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Status'" [sortModel]="tableSortModel.columns.get('status')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Datum Auftrag'" [sortModel]="tableSortModel.columns.get('datumAuftrag')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Beschreibung'" [sortModel]="tableSortModel.columns.get('beschreibung')"></cap-column-header>
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        <cap-kompakt-geometergeschaeft
          [canViewGeoGeschaeftDetails]="canViewGeoGeschaeftDetails"
          [item]="item.geometergeschaeft"></cap-kompakt-geometergeschaeft>
      </td>
      <td>
        {{ item.status | translate }}
      </td>
      <td>
        {{ item.auftragsDatum | datum }}
      </td>
      <td>
        {{ item.beschreibung }}
      </td>
    </tr>
  }
</ng-template>
